import { Lightning, Lightning as lng } from '@lightningjs/sdk';
import { Theme } from '../../../../config/theme';
import { GlobalSettingsKeys } from '../../../../api/models/GlobalSettingsKeys';

const constant = {
  h: 95,
  padding: 24,
};

export class SearchCompletionItem extends lng.Component {
  static _template() {
    return {
      h: constant.h,
      x: 0,
      y: 0,

      Bg: {
        rect: true,
        color: Theme.Colors.SearchCompletion.Bg.unfocused,
        h: constant.h,
        w: 10,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: constant.h / 2,
        },
      },

      Text: {
        mount: 0.5,
        y: h => h / 2,
        x: w => w / 2,
        text: {
          ...Theme.Fonts.Default,
          textAlign: 'center',
          text: '',
          fontSize: 32,
        },
      },
    };
  }

  _init() {
    this.tag('Text').on('txLoaded', () => {
      this.tag('Bg').w = this.tag('Text').finalW + constant.padding * 2;
      this.w = this.tag('Text').finalW + constant.padding * 2;
    });
    this.tag('Text').text.text = this.getDisplayText();
  }

  getDisplayText() {
    let cutOff = this.backend.globalSettings.numberValue(GlobalSettingsKeys.searchMaxSuggestionLength);
    cutOff = cutOff ? cutOff : 20;
    return this.data && this.data.length > cutOff ? this.data.slice(0, cutOff) + '…' : this.data;
  }

  _handleEnter() {
    this.signal('completionPressed', this.data);
  }

  _focus() {
    this.tag('Bg').color = Theme.Colors.SearchCompletion.Bg.focused;
  }

  _unfocus() {
    this.tag('Bg').color = Theme.Colors.SearchCompletion.Bg.unfocused;
  }
}
